import { TaskApproved } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Модерация (БО-10, Приложение D «модерация»): сертификаты и документы, подтверждения мест работы, отзывы до
 * публикации, ответы и споры, жалобы, материалы сообщества; решение с причиной; амбассадоры (HR-31).
 * Роли: DODOC_MODERATOR, DODOC_ADMIN (backoffice/exchange/*).
 */
export const section = defineSection({
  id: 'backoffice.moderation',
  area: 'backoffice',
  path: 'moderation/*',
  roles: ['DODOC_MODERATOR', 'DODOC_ADMIN'],
  icon: TaskApproved,
  titleKey: 'moderation:title',
  namespaces: ['backoffice', 'exchange', 'community'],
  navGroup: 'quality',
  order: 100,
  load: () => import('./ModerationPage'),
});
